import React, { useRef, useState } from 'react';
import { Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import './Note.scss';

import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import { INoteState } from '@/pages/Active/Active';
import { DynRelatedToData } from '@/services/dynamics/interfaces/relate-to-info.interface';

import acceptIcon from '@/public/icons/accept.svg';
import cancelIcon from '@/public/icons/cancel.svg';

const MAX_LENGTH = 2000;

interface INoteProps {
  note: INoteState;
  savePhoneCallHandler: ({
    noteId,
    noteText,
    noteRelatedInfo,
  }: {
    noteId: string;
    noteText: string;
    noteRelatedInfo: DynRelatedToData;
  }) => Promise<string>;
}

export function NoteReduced({ note, savePhoneCallHandler }: INoteProps) {
  const textArea = useRef(null);

  const [counter, setCounter] = useState(0);
  const [saving, setSaving] = useState(false);
  const [innerNote, setInnerNote] = useState<INoteState>(note);
  const [prevText, setPrevText] = useState<string>(note.text);

  const saveNote = async () => {
    setSaving(true);

    const { id, text, relatedToData } = innerNote;

    const recordId = await savePhoneCallHandler({
      noteId: id,
      noteText: text,
      noteRelatedInfo: relatedToData,
    });
    setInnerNote({
      id: recordId,
      text,
      relatedToData,
      assignToData: note.assignToData,
    });
    setPrevText(text);
    setSaving(false);
    setCounter(0);
  };

  const inputEvent = (event) => {
    const { target } = event;

    setCounter(target.value.length);

    setInnerNote({
      id: innerNote.id,
      text: target.value,
      relatedToData: innerNote.relatedToData,
      assignToData: note.assignToData,
    });
    event.preventDefault();
  };

  const getBackToPrevSavedText = () => {
    setInnerNote({ ...innerNote, text: prevText });
    setCounter(0);
  };

  return (
    <div className="note">
      <div className="note__main">
        <div className="main-text note__header">Write a note</div>
        <div className="note__textarea-wrapper">
          <div className="note__textarea">
            <TextArea
              ref={textArea}
              data-testid="note-textarea"
              autoSize={{ minRows: 5 }}
              showCount
              maxLength={MAX_LENGTH}
              disabled={saving}
              onChange={(e) => inputEvent(e)}
              placeholder="Please, write a phone call note"
              defaultValue={innerNote?.text}
              value={innerNote?.text}
            ></TextArea>
          </div>
        </div>
      </div>
      <div className="note__controls note__controls--two-cols">
        <div className="note__controls-col">
          <Button
            disabled={!counter}
            className="note__btn"
            data-testid="cancel-note"
            type="default"
            onClick={() => getBackToPrevSavedText()}
            icon={<MessageIcon svgUrl={cancelIcon} />}
          >
            Cancel
          </Button>
        </div>
        <div className="note__controls-col">
          <Button
            loading={saving}
            disabled={!counter}
            className="note__btn"
            data-testid="save-note"
            type="primary"
            onClick={() => saveNote()}
            icon={<MessageIcon svgUrl={acceptIcon} />}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}
